export default function PHP_Shorthand_If() {
  return (
    <div>
      <h1>PHP_Shorthand_If</h1>
    </div>
  );
}
